import {
    useEffect,
    useState,
    useSyncExternalStore,
    type ReactNode,
} from "react";
import {
    createBrowserRouter,
    RouterProvider,
    useBlocker,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
    confirmFormNavigation,
    hasDirtyForms,
    subscribeDirtyForms,
} from "@/hooks/useFormProtection";

const NavigationGuard = ({ children }: { children: ReactNode }) => {
    const dirty = useSyncExternalStore(
        subscribeDirtyForms,
        hasDirtyForms,
        () => false
    );
    const blocker = useBlocker(dirty);
    useEffect(() => {
        if (blocker.state === "blocked") {
            confirmFormNavigation(blocker.proceed, blocker.reset);
        }
    }, [blocker]);
    return children;
};

export const ApplicationRouter = ({ children }: { children: ReactNode }) => {
    const [queryClient] = useState(() => new QueryClient());
    const [router] = useState(() =>
        createBrowserRouter([
            {
                path: "*",
                element: <NavigationGuard>{children}</NavigationGuard>,
            },
        ])
    );
    return (
        <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
        </QueryClientProvider>
    );
};
